module.exports = {"unknownError":"Something went wrong","close":"Close","myAccount":"My Account","filter":"Filter","paid":"Paid"}